function switchTab(tabId) {
    document.querySelectorAll('.tab-content').forEach(content => { content.classList.add('hidden'); });
    document.getElementById(tabId).classList.remove('hidden');
    document.querySelectorAll('.tab-btn').forEach(btn => {
        btn.classList.remove('bg-white', 'text-navyBase-900', 'shadow-sm');
        btn.classList.add('text-slate-600', 'hover:text-navyBase-900');
    });
    const activeBtn = document.getElementById('btn-' + tabId);
    activeBtn.classList.add('bg-white', 'text-navyBase-900', 'shadow-sm');
    activeBtn.classList.remove('text-slate-600', 'hover:text-navyBase-900');
}

function toggleAccordion(faqId) {
    const element = document.getElementById(faqId);
    const icon = document.getElementById('icon-' + faqId);
    element.classList.toggle('hidden');
    if(element.classList.contains('hidden')) {
        icon.style.transform = "rotate(0deg)";
    } else {
        icon.style.transform = "rotate(180deg)";
    }
}